import React from 'react';
import { ethers } from 'ethers';
import { formatUSDT } from '../../utils/format';

/**
 * Rewards breakdown — 2 segments now (contract has mining + 12-level rewards, no binary/referral split).
 */
export default function IncomeBreakdown({ mining, levelIncome }) {
  const m = numFrom(mining);
  const l = numFrom(levelIncome);
  const total = m + l;

  const pctM = total > 0 ? (m / total) * 100 : 0;
  const pctL = total > 0 ? (l / total) * 100 : 0;

  const size = 220;
  const stroke = 18;
  const radius = (size / 2) - stroke;
  const circ = 2 * Math.PI * radius;

  const dashM = (pctM / 100) * circ;
  const dashL = (pctL / 100) * circ;
  const offL = -dashM;

  return (
    <div className="income-panel">
      <div className="income-header">
        <h3>Rewards Breakdown</h3>
        <div className="total">
          {formatUSDT(mining.add(levelIncome))} <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>USDT</span>
        </div>
      </div>

      <div className="income-body">
        <div className="donut-wrap">
          <svg className="donut-svg" viewBox={`0 0 ${size} ${size}`}>
            <circle className="donut-track" cx={size/2} cy={size/2} r={radius} />
            {total > 0 && (
              <>
                <circle
                  className="donut-segment"
                  cx={size/2}
                  cy={size/2}
                  r={radius}
                  style={{ stroke: 'var(--accent)' }}
                  strokeDasharray={`${dashM} ${circ - dashM}`}
                  strokeDashoffset={0}
                />
                <circle
                  className="donut-segment"
                  cx={size/2}
                  cy={size/2}
                  r={radius}
                  style={{ stroke: '#B77DFF' }}
                  strokeDasharray={`${dashL} ${circ - dashL}`}
                  strokeDashoffset={offL}
                />
              </>
            )}
          </svg>
          <div className="donut-center">
            <div className="dc-label">Total Earned</div>
            <div className="dc-value">{formatUSDT(mining.add(levelIncome), 0)}</div>
            <div className="dc-sub">USDT</div>
          </div>
        </div>

        <div className="income-list">
          <IncomeRow className="income-mining"   label="Mining Rewards"  value={mining}      pct={pctM} />
          <IncomeRow className="income-referral" label="Level Rewards"   value={levelIncome} pct={pctL} />
        </div>
      </div>
    </div>
  );
}

function IncomeRow({ className, label, value, pct }) {
  return (
    <div className={`income-row ${className}`}>
      <div className="ir-top">
        <div className="ir-title">
          <span className="dot" />
          {label}
        </div>
        <div className="ir-amount">{formatUSDT(value)} USDT</div>
      </div>
      <div className="ir-bar">
        <div className="ir-bar-fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="ir-pct">
        <span>{pct.toFixed(1)}%</span>
      </div>
    </div>
  );
}

function numFrom(bn) {
  try {
    return Number(ethers.utils.formatUnits(bn || 0, 18));
  } catch {
    return 0;
  }
}
